import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <img
                src="/vetriaAI.png"
                alt="VetriaAI Logo"
                className="w-10 h-10"
              />
              <span className="text-2xl font-bold text-gray-900">VetriaAI</span>
            </div>
            <Link
              to="/"
              className="flex items-center text-gray-600 hover:text-gray-900 font-medium"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <pre className="text-gray-900 font-sans whitespace-pre-line text-base leading-relaxed">
{`VetriaAI Privacy Policy

Last Updated: 09 October 2025

This Privacy Policy explains how VetriaAI processes personal data for HR teams, recruiters, candidates, and visitors.

1) Who We Are
VETRIAAI INNOVATION PRIVATE LIMITED
Registered Office: H. No. 5-95/1, Flat No. G, Mokkapati Towers, Fathenagar Colony, K.v.rangareddy, Balanagar, Telangana, India, 500018
Contact: info@vetriaai.com

2) Scope
This policy covers our website, apps, APIs, and services related to AI-powered testing, candidate screening, analytics, and badges.

3) Data We Collect
Account & Workspace Data: names, emails, phone (optional), company, role, login metadata, MFA settings
Recruitment Data: job descriptions, resumes/CVs, assessments, scores, interview notes, badges/certifications
Usage & Device Data: IP, device identifiers, logs, performance metrics, cookie IDs
Payment Data: billing contact, address, transaction metadata (processed by PCI-compliant providers)
Support & Feedback: tickets, chats, survey responses
Integrations: data exchanged with ATS/CRM/communication tools per your configuration

4) How We Use Data
Provide, secure, and improve the Service
Generate tests and insights; verify skills; issue badges
Configure integrations; provide analytics dashboards
Detect, prevent, and investigate fraud, abuse, and security incidents
Communicate about service updates, billing, and support
Comply with legal obligations

5) Legal Bases (GDPR)
Contractual necessity (providing the Service)
Legitimate interests (security, product improvement, analytics)
Consent (where required\u2014for certain cookies, marketing, or candidate processing if relying on consent)
Legal obligations (tax, compliance)

6) Automated Processing & Human Review
AI assists with screening and assessments. Automated suggestions do not replace human decisions.
Users can request human review of significant outcomes affecting them.

7) Sharing & Disclosure
We share data with:
Processors (cloud hosting, email, analytics, payment) under data processing agreements
Integrations you enable (ATS/CRM/communications)
Legal authorities when required by law
We do not sell personal data.

8) International Transfers
Data may be processed in multiple regions with geographic redundancy
Transfers use SCCs, adequacy decisions, or comparable safeguards

9) Security
Encryption at rest and in transit (AES-256/TLS)
MFA, RBAC, audit trails, 24/7 monitoring, DDoS protection, daily backups
Regular audits aligned with SOC 2 Type II and ISO 27001 practices

10) Data Retention
Follows your workspace settings by default
Minimizes data and purges when no longer needed
On account closure, data is securely deleted after required retention periods unless law requires longer storage

11) Your Rights
Depending on your region (e.g., GDPR, CCPA), you may:
Access, correct, delete, or download your data
Object to or restrict processing; withdraw consent
Not be subject solely to automated decisions with legal or similar significant effects
Requests: info@vetriaai.com
 (we may verify your identity)

12) Cookies & Tracking
Essential cookies for login and security
Analytics/functional cookies with consent where required
Manage preferences via our cookie banner or browser settings

13) Children\u2019s Data
Service is not for children under 16 (or lower age permitted by local law)
We don\u2019t knowingly collect such data

14) Data Protection Officer (DPO) & Contact
DPO/Privacy: info@vetriaai.com
Support: info@vetriaai.com
Address: H. No. 5-95/1, Flat No. G, Mokkapati Towers, Fathenagar Colony, K.v.rangareddy, Balanagar, Telangana, India, 500018

15) Changes to this Policy
Updates will be posted here with a revised \u201CLast updated\u201D date
Material changes will be communicated through the app or by email`}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
